import { render } from "./Radio.vue?vue&type=template&id=7acec7da"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"backend/vue/imagecontentpluginform/Radio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7acec7da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7acec7da', __exports__)) {
    api.reload('7acec7da', __exports__)
  }
  
  module.hot.accept("./Radio.vue?vue&type=template&id=7acec7da", () => {
    api.rerender('7acec7da', render)
  })

}


export default __exports__